import React, { useState, useContext, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { AppScopeProvider } from '../../context/AppScopeContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import useResponsiveTables from '../../utils/useResponsiveTables';

const Layout = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { user } = useContext(AuthContext);
  // Phone: data tables render as cards (see index.css).
  const mainRef = useRef(null);
  useResponsiveTables(mainRef);

  return (
    <AppScopeProvider>
    <div className="flex h-screen w-full overflow-hidden bg-gradient-to-br from-gray-100 to-white dark:from-gray-800 dark:to-gray-900">
      {/* Mobile overlay backdrop */}
      {/* Skip link for keyboard users */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[70] focus:bg-white focus:text-primary-black focus:px-3 focus:py-2 focus:rounded-lg focus:shadow">
        Skip to content
      </a>
      {isExpanded && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setIsExpanded(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <Sidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />

      {/* Main content */}
      <div className={`flex flex-col flex-1 min-w-0 transition-[margin] duration-300 ${isExpanded ? 'md:ml-64' : 'md:ml-16'}`}>
        <Topbar isSidebarOpen={isExpanded} toggleSidebar={setIsExpanded} />
        <main ref={mainRef} id="main-content" className="flex-1 overflow-y-auto overflow-x-hidden px-2 md:px-4 xl:px-8 mx-0 sm:mx-2 xl:mx-5">
          <Outlet />
        </main>
      </div>
    </div>
    </AppScopeProvider>
  );
};

export default Layout;
